import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { usePurchaseableProductsForTerm } from '../../../hooks/useBulkPurchaseOptions';
import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import SkeletonLoadWrapper from '../../common/loading/SkeletonLoadWrapper';
import { useShowPricePerMonthPerSeat } from '../seats-display/useSeatsDisplay';
import FreePriceDisplayStyled from './FreePriceDisplayStyled';
import { PriceDisplayStyled } from './PriceDisplayStyled';
import { jsx as _jsx } from "react/jsx-runtime";
export const PriceDisplayContainer = ({
  skuId,
  queryParamTerm,
  nonMerchandiseIdProduct,
  apiName,
  isHubspotFree = false
}) => {
  const isAppReady = useGlobalLoading();
  const {
    purchaseOptionsForTerm,
    loading: purchaseOptionsForTermLoading
  } = usePurchaseableProductsForTerm({
    queryParamTerm,
    apiName
  });
  const showPricePerMonthPerSeat = useShowPricePerMonthPerSeat({
    skuId
  });
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();
  const loading = !isAppReady || purchaseOptionsForTermLoading;
  if (!purchaseOptionsForTerm && !loading) {
    return null;
  }
  if (isHubspotFree) {
    return /*#__PURE__*/_jsx(FreePriceDisplayStyled, {});
  }
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: loading
    // First block is for "Starts at"
    // Second block is for the price
    ,
    heights: [20, 33],
    widths: [60, 80],
    children: purchaseOptionsForTerm && /*#__PURE__*/_jsx(PriceDisplayStyled, {
      pricingInfo: purchaseOptionsForTerm,
      showPricePerMonthPerSeat: showPricePerMonthPerSeat,
      seleniumId: apiName || nonMerchandiseIdProduct || 'loading',
      currencyCode: currencyCode,
      currencyCodeUnit: currencyCodeUnit
    })
  });
};